"use strict";

define('rs/modals/workflow/workflow.controller',['e3-modal'], function (E3Modal) {
  var WorkflowController = E3Modal.BtnMsgModal.extend({
    defaultTitle: 'Submission Routing',
    properties: ['workflowService', 'answerValue'],
    buttons: [{
      text: 'Cancel',
      icon: 'ban',
      dismiss: true
    }, {
      text: 'Confirm',
      color: 'primary',
      icon: 'check'
    }],
    getTemplateProperties: function getTemplateProperties() {
      var workflowService = this.getWorkflowService(),
        confirmationMessage = workflowService.getAnswerConfirmationByValue(this.getAnswerValue());
      if (workflowService.getTaskName() == 'CERTIFY') {
        this.setTitle('Submission Certification');
        var roles = _.chain(this.getWorkflowService().getDocumentService().getCurrentUserAssignments()).pluck('assignmentType').pluck('displayName').value();
        if (roles.length > 2) {
          var temp = roles.splice(0, roles.length - 1);
          temp.push("");
          roles.unshift(temp.join(", "));
        }
        var roleText = roles.join(" and ");
        confirmationMessage = confirmationMessage.replace(/\[ROLE\]/g, roleText);
      }
      return {
        message: confirmationMessage
      };
    }
  }, {
    setupModalOptions: function setupModalOptions(options) {
      return options || null;
    }
  });
  return WorkflowController;
});

